/*
 * Handles subscription page template form.
 * If the user want's to become a member send user data to backend
 */
jQuery( '#subcribe-as-member' ).on( 'submit', function( e ) {
	e.preventDefault();
	const agreeCheckbox = document.getElementById( 'book_subscription' );

	if ( ! agreeCheckbox.checked ) {
		return;
	}

	const user = { id: ajaxSubscribe.current_user_id }; // eslint-disable-line no-undef
	const submitButton = document.getElementById( 'book_club_submit' );
	submitButton.disabled = true;

	jQuery.ajax( {
		method: 'POST',
		// Membership set to true
		url: ajaxSubscribe.rest_root + 'wc-cle/v1/book-club/status/1', // eslint-disable-line no-undef
		data: user,
		beforeSend( xhr ) {
			xhr.setRequestHeader( 'X-WP-Nonce', ajaxSubscribe.nonce ); // eslint-disable-line no-undef
		},
		success: response => {
			if ( ! response ) {
				window.location.href = ajaxSubscribe.home_url; // eslint-disable-line no-undef
			}

			// Make new request that generates coupon code and emails to client
			jQuery.ajax( {
				method: 'POST',
				url: ajaxSubscribe.rest_root + 'wc-cle/v1/book-club/coupon/', // eslint-disable-line no-undef
				data: user,
				beforeSend( xhr ) {
					xhr.setRequestHeader( 'X-WP-Nonce', ajaxSubscribe.nonce ); // eslint-disable-line no-undef
				},
				success() {
					window.location.href = ajaxSubscribe.home_url; // eslint-disable-line no-undef
				},
				fail() {
					window.location.href = ajaxSubscribe.home_url; // eslint-disable-line no-undef
				},
			} );
		},
		fail() {
		},

	} );
} );

jQuery( '.subscription-response' ).on( 'DOMSubtreeModified', function() {
	jQuery( '.subscription-response' ).text( function() {
		return jQuery( this ).text().replace( 'Ett fel uppstod, var god försök senare.', 'E-posten finns redan registrerad.' );
	} );
} );
